const dadosEmpresa = [
    {
        name: 'dadosEmpresaParceiro',
        path: '/parceiro/configuracoes/dados_empresa',
        alias: [
            '/contabilidade/configuracoes/dados_empresa'
        ],
        component: () => import('../views/DadosEmpresa')
    }
]
const marcaEmpresa = [
    {
        name: 'marcaEmpresaParceiro',
        path: '/parceiro/configuracoes/marca_empresa',
        alias: [
            '/contabilidade/configuracoes/marca_empresa'
        ],
        component: () => import('../views/MarcaEmpresa')
    }
]
export default [
    ...dadosEmpresa,
    ...marcaEmpresa,
]